import { useState, useEffect } from 'react';
import { analyticsService, OverviewMetrics, FieldPrecision, Suggestion, WorstOcrPage, ModelPerformance } from '../services/analyticsService';

export function useAnalytics(domain?: string) {
  const [overview, setOverview] = useState<OverviewMetrics | null>(null);
  const [fields, setFields] = useState<FieldPrecision[]>([]);
  const [suggestions, setSuggestions] = useState<Suggestion[]>([]);
  const [worstOcr, setWorstOcr] = useState<WorstOcrPage[]>([]);
  const [modelPerf, setModelPerf] = useState<ModelPerformance[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const [overviewRes, worstOcrRes, modelPerfRes] = await Promise.all([
        analyticsService.getOverview(domain),
        analyticsService.getWorstOcrPages(),
        analyticsService.getModelPerformance(),
      ]);

      setOverview(overviewRes.data);
      setWorstOcr(worstOcrRes.data);
      setModelPerf(modelPerfRes.data);

      if (domain) {
        const [fieldsRes, suggestionsRes] = await Promise.all([
          analyticsService.getFieldPrecision(domain),
          analyticsService.getSuggestions(domain),
        ]);
        setFields(fieldsRes.data);
        setSuggestions(suggestionsRes.data);
      }
    } catch (err) {
      setError('Erreur lors du chargement des analytics');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [domain]);

  return { overview, fields, suggestions, worstOcr, modelPerf, isLoading, error, refetch: fetchData };
}
